const supportedLocales = new Set(['it', 'en', 'fr', 'de']);

export const normalizeVueformLocale = (locale = 'it') => {
    const language = String(locale || 'it').replaceAll('_', '-').split('-')[0].toLowerCase();
    return supportedLocales.has(language) ? language : 'it';
};

// Keep locale synchronization independent of the form library and its custom fields.
export const syncVueformLocale = (app, locale = 'it') => {
    const normalized = normalizeVueformLocale(locale);
    const vueform = app?.config?.globalProperties?.$vueform;

    if (vueform?.config) vueform.config.locale = normalized;
    if (vueform?.i18n) vueform.i18n.locale = normalized;

    return normalized;
};
